<template>
  <div class="">
    <el-button size="small" type="primary" @click="openSend"
      >合作商发卡</el-button
    >

    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
    </auto-table>

    <el-dialog title="合作商发卡" :visible.sync="sendShow" width="30%">
      <el-form ref="form" label-width="100px">
        <el-form-item label="生成方式" required>
          <el-radio v-model="send_type" label="mobiles">手动填写</el-radio>
          <el-radio v-model="send_type" label="excel">导入表格</el-radio>
        </el-form-item>
        <div v-if="send_type == 'mobiles'">
            
          <div class="flex" v-for="(v, i) in memberList" :key="i">
            <el-form-item label="姓名" required>
              <el-input class="input-new-tag" v-model="v.name" size="small">
              </el-input>
            </el-form-item>
            <el-form-item label="电话" required>
              <el-input class="input-new-tag" v-model="v.phone" size="small">
              </el-input>
            </el-form-item>
          </div>
          <el-button
                type="primary"
                @click.stop="addMemberForm"
                >新增一行</el-button
              >
        </div>
        <div v-if="send_type == 'excel'">
          <el-form-item label="发放用户" required>
            <el-upload
              action=""
              :on-change="beforeUpload"
              :file-list="fileList"
              :auto-upload="false"
              :show-file-list="true"
              accept=".xls, .xlsx"
              list-type="text"
              :limit="1"
              ref="upload"
            >
              <el-button type="success" size="small">导入表格</el-button>
              <el-button
                type="text"
                @click.stop="loadTemplate"
                style="margin: 10px"
                >下载模板</el-button
              >
            </el-upload>
          </el-form-item>
        </div>
        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="margin-left: 30px" @click="sendShow = false"
          >取消</el-button
        >
        <el-button
          v-if="send_type == 'mobiles'"
          style="margin-left: 20px"
          type="primary"
          @click="batchInsert"
          :loading="loading"
          >确认</el-button
        >
        <el-button
          v-if="send_type == 'excel'"
          style="margin-left: 20px"
          type="primary"
          :loading="loading"
          @click="importMemberExcel"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from "xlsx";
export default {
  data() {
    return {
      DataList: [],
      Option: [
        { name: "姓名", value: "name" },
        { name: "电话", value: "phone" },
        { name: "导入时间", value: "create_time" },
      ],
      Total: 0,
      sendShow: false,
      fileData: "",
      send_type: "mobiles",
      loading: false,
      fileList: [],
      memberList: [],
      cooperator_id: "",
      managerInfo:JSON.parse(localStorage.getItem("managerInfo")),
    };
  },

  mounted() {
    this.cooperator_id = this.$route.query.id;
  },

  methods: {
    addMemberForm(){
        this.memberList.push({
          name: "",
          phone: "",
        });
    },
    loadTemplate() {
       let Header = [["电话", "姓名"]];
        let exportArr = [["188**", "张三"]];

      const headerWs = XLSX.utils.aoa_to_sheet(Header);
      const ws = XLSX.utils.sheet_add_json(headerWs, exportArr, {
        skipHeader: true,
        origin: "A2",
      });
      ws["!cols"] = [
        {
          wpx: 100,
        },
        {
          wpx: 100,
        }
      ];
      /* 新建空的工作表 */
      const wb = XLSX.utils.book_new();

      // 可以自定义下载之后的sheetname
      XLSX.utils.book_append_sheet(wb, ws, "sheetName");

      /* 生成xlsx文件 */
      XLSX.writeFile(wb, "会员用户导入模板.xlsx");
      this.$message("导出成功，请前往下载列表查看");
    },
    upLoad(file) {
    
    },
   
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },

    importMemberExcel() {
      if (!this.fileData) {
        this.$message("请选择要导入的数据");
        return;
      }
      let formDate = new FormData();
      formDate.append("file", this.fileData);
      formDate.append("admin_id", this.managerInfo.id);
      formDate.append("admin_name", this.managerInfo.name);
      formDate.append("coop_id", this.cooperator_id);
      this.loading = true;
      this.$axios({
        url: "/user/coopExportMember/importMemberExcel",
        data: formDate,
        method: "post",
        processData: false,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((res) => {
          this.getList(1);
          this.$message({ message: res.data.data });
          this.sendShow = false;
          this.loading = false;
          this.fileList = [];
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //合作商发卡
    batchInsert() {
      if (this.memberList.length == 0) {
        this.$message("请填写用户");
        return;
      }
     
      let data = {
         coop_id: this.cooperator_id,
         list: this.memberList,
         admin_id: this.managerInfo.id,
         admin_name: this.managerInfo.name
      };
      this.loading = true;
      this.$axios
        .post("/user/coopExportMember/batchInsert", data)
        .then((res) => {
          this.getList(1);
          this.$message({ message: res.data.message });
          this.sendShow = false;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    openSend() {
      this.sendShow = true;
    },
    load() {
      if (this.DataList.length == 0) {
        this.getList(1);
      }
    },
    details(row) {
      this.$router.push({ name: "cooperatorDetails", query: { id: row.id } });
    },
    //分成记录
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/coopExportMember/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          coop_id: this.cooperator_id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
    empty() {
      return;
    },
    // 文件选择回调
    beforeUpload(file) {
      this.fileData = file.raw;
      this.readExcel(); // 调用读取数据的方法
    },
    // 读取数据
    readExcel(e) {
      const files = this.fileData;

      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
          console.log(ws);
        } catch (e) {
          return false;
        }
      };
    },
  },
};
</script>

<style lang="less" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
a:hover {
  color: #333;
}

.table {
  height: 30px;
  line-height: 30px;
  border: 1px solid #333;
  border-bottom: none;
  padding: 0 10px 0 2px;
}
</style>